import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import EmployeeList from "./EmployeeList";
import CreateNewEmployee from "./CreateNewEmployee";
import Excelldownload from "./Excelldownload";
import { getAllLocation, getAllLocationPlain } from "../../../actions/warehouseAction";
import { getAllDepartment } from "../../../actions/departmentActions";
import { getAllUserRole } from "../../../actions/userRoleAction";
import { syncAllEmployeebyPagination, syncAllResignedEmployeebyPagination } from "../../../actions/employeeAction";
import { DatePicker, Select, TreeSelect, Col, Space, Row, Spin, Divider, AutoComplete, Button, Modal  } from "antd";
import { getEmployeeStats } from "../../../actions/employeeAction";

const { Option } = Select;

const Maincontent = ({ auth, getAllLocationPlain, syncAllEmployeebyPagination, getEmployeeStats, syncAllResignedEmployeebyPagination, locationList, getAllDepartment, departmentList, getAllUserRole, RoleList }) => {
  const [updatelist, setUpdatelist] = useState(true);
  const [reload, setReload] = useState(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const location = useRef("")
  const Designation = useRef("")
  const Department = useRef("")
  const keyword = useRef("")
  const flag = useRef(false)
  const [loading, setloading] = useState(false);
  const [data, setData] = useState([]);
  const [employeeloading, setEmployeeLoading] = useState(false);
  const [resignedemployeeloading, setResignedEmployeeLoading] = useState(false);
  const progress = useRef(0)
  const [employeeStats, setEmployeeStats] = useState({
    total_active: 0,
    total_resigned: 0,
  });
  const [isSyncModalVisible, setIsSyncModalVisible] = useState(false);
  const [syncCount, setSyncCount] = useState(0);
  const isWorker = useRef("all");

    useEffect(() => {
    getAllLocationPlain();
    getAllDepartment();
    getAllUserRole();

    getEmployeeStats().then((stats) => {
      console.log("Employee Stats:", stats);
      if (stats) {
        setEmployeeStats(stats);
      }
    });
  }, []);

  const callbackfuncation = (i) => {
    syncAllEmployeebyPagination(i, 5)
      .then((e) => {
        if (e && e.logs) {
          console.log("Active Employee Logs:", e.logs);
          setSyncCount((prev) => prev + 1); 
        }

        if (!e || e.next === null) {
          setEmployeeLoading(false);
          setIsSyncModalVisible(false); 
          return;
        }

        i = i + 1;
        progress.current = i;
        callbackfuncation(i);
      })
      .catch((error) => {
        console.error("Sync employee error:", error);
        setEmployeeLoading(false);
        setIsSyncModalVisible(false);
      });
  };



  const callbackfuncationforResigned = (i) => {
    syncAllResignedEmployeebyPagination(i, 10)
      .then((e) => {
        if (e && e.logs) {
          console.log("Resigned Logs:", e.logs);
        }

        if (!e || e.next === null) {
          setResignedEmployeeLoading(false);
          return;
        }

        i = i + 1;
        callbackfuncationforResigned(i);
      })
      .catch((err) => {
        console.error("Error syncing resigned employees:", err);
        setResignedEmployeeLoading(false);
      });
  };

  const syncdata = () => {
    setEmployeeLoading(true);
    setIsSyncModalVisible(true);
    setSyncCount(0);
    progress.current = 1;
    callbackfuncation(1);
  };

  const syncresigneddata = () => {
    setResignedEmployeeLoading(true)
    progress.current = 1;
    callbackfuncationforResigned(1);
  }

  return (
    <>
      <div className="site-layout-background main-frame">
        <Modal
          title="Syncing Employee Data"
          visible={isSyncModalVisible}
          footer={null}
          closable={false}
        >
          <p>Syncing in progress...</p>
          <p>Successful Requests: {syncCount}</p>
        </Modal>
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col>
            <div>
              <Button style={{ marginRight: "10px" }} onClick={syncdata} >{employeeloading ? "loading...." : "Sync employee data"}</Button>
              <Button onClick={syncresigneddata} >{resignedemployeeloading ? "loading...." : "Sync resigned employee data"}</Button>
            </div>
          </Col>
          <Col>
            <div style={{ fontWeight: "bold", color: "green" }}>
              Total Active Employees: {employeeStats.total_active}
            </div>
          </Col>
          <Col>
            <div style={{ fontWeight: "bold", color: "red" }}>
              Total Resigned Employees: {employeeStats.total_resigned}
            </div>
          </Col>
        </Row>

        <Divider />
        <Row wrap={false}>
          <Col flex="auto">
            keyword :
            <AutoComplete
              placeholder="EPIN / Name / Phone"
              // onChange={onChange}
              onChange={(value) => {
                keyword.current = value;
              }}
              style={{ width: "100%", minWidth: "140px" }}
            />
          </Col>
          <Col flex="auto">
            Area :
            <Select
              showSearch
              optionFilterProp="children"
              placeholder="Please select a area"
              // defaultValue={location.current}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              onChange={(value) => {
                location.current = value
                // setReload(!reload);
              }}
              style={{ width: "100%", }}
            >
              <Option value="">All</Option>
              {locationList.map(warehouse => {
                return <Option value={warehouse.id}>{warehouse.name}</Option>;
              })}

            </Select>
          </Col>
          <Col flex="auto">
            Department:
            <Select
              placeholder="Please select a department"
              style={{ width: "100%" }}
              onChange={(e) => {
                Department.current = e;
              }}
            >
              <Option value="">All</Option>
              {departmentList.map((department) => {
                return <Option value={department.id}>{department.name}</Option>;
              })}
            </Select>
          </Col>
          <Col flex="auto">
            Designation:
            <Select
              placeholder="Please select a designation"
              style={{ width: "100%" }}
              onChange={(e) => {
                Designation.current = e;
              }}
            >
              <Option value="">All</Option>
              {RoleList.map((role) => {
                return <Option value={role.id}>{role.name}</Option>;
              })}
            </Select>
          </Col>
               <Col flex="auto">
            Worker:
            <Select
              placeholder="All"
              defaultValue="all"
              style={{ width: "100%" }}
              onChange={(e) => {
                isWorker.current = e;
              }}
            >
              <Option value="all">All</Option>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </Col>
          <Col flex="auto">
            .
            <Button style={{ width: "100%" }} onClick={() => {
              flag.current = true;
              setReload(!reload)
            }}>Search</Button>
          </Col>
          {auth.permissions.includes("HRM.Employee_is_create") ? (
            <Col flex="auto">
              .
              <CreateNewEmployee
                setUpdatelist={setUpdatelist}
                updatelist={updatelist}
              />
            </Col>
          ) : (
            ""
          )}
        </Row>        
        <Divider />
  

        <Spin spinning={loading}>
          <EmployeeList
            loading={loading}
            setloading={setloading}
            location={location}
            Designation={Designation}
            Department={Department}
            Keyword={keyword}
            reload={reload}
            flag={flag}
            isWorker={isWorker}
            setReload={setReload}
            data={data}
            setData={setData}
            pageno={pageno}
            page_size={page_size}
            setParentLoading={setloading}
          />
        </Spin>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    locationList: state.warehouse.locationlist,
    departmentList: state.department.departmentlist,
    RoleList: state.userRole.userRolelist,
  };
};

export default connect(mapStateToProps, { getAllLocationPlain, getAllDepartment, getAllUserRole, syncAllEmployeebyPagination, syncAllResignedEmployeebyPagination, getEmployeeStats, })(Maincontent);
